export function createMovieCard(movie) {
  const card = document.createElement('a');
  card.href = `#/movie/${movie.id}`;
  card.className = 'movie-card clickable-item';

  card.innerHTML = `
    <div class="card-poster-wrap">
      <img src="${movie.poster}" alt="${movie.title}" class="card-poster" loading="lazy" />
      <div class="rating-badge">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
        </svg>
        <span>${movie.rating || 'N/A'}</span>
      </div>
    </div>
    <div class="card-body">
      <h3 class="card-title">${movie.title}</h3>
      <div class="card-sinhala">${movie.sinhalaTitle || ''}</div>
      <div class="card-meta">
        <span>${movie.year}</span>
        ${movie.genres && movie.genres.length ? `• <span>${movie.genres[0]}</span>` : ''}
      </div>
    </div>
  `;

  return card;
}
